"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserDetailsAdminDto = instanceOfUserDetailsAdminDto;
exports.UserDetailsAdminDtoFromJSON = UserDetailsAdminDtoFromJSON;
exports.UserDetailsAdminDtoFromJSONTyped = UserDetailsAdminDtoFromJSONTyped;
exports.UserDetailsAdminDtoToJSON = UserDetailsAdminDtoToJSON;
exports.UserDetailsAdminDtoToJSONTyped = UserDetailsAdminDtoToJSONTyped;
/**
 * Check if a given object implements the UserDetailsAdminDto interface.
 */
function instanceOfUserDetailsAdminDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    if (!('propertiesListed' in value) || value['propertiesListed'] === undefined)
        return false;
    if (!('offersMade' in value) || value['offersMade'] === undefined)
        return false;
    if (!('bidsMade' in value) || value['bidsMade'] === undefined)
        return false;
    return true;
}
function UserDetailsAdminDtoFromJSON(json) {
    return UserDetailsAdminDtoFromJSONTyped(json, false);
}
function UserDetailsAdminDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'email': json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'isVerified': json['isVerified'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'propertiesListed': json['propertiesListed'],
        'offersMade': json['offersMade'],
        'bidsMade': json['bidsMade'],
    };
}
function UserDetailsAdminDtoToJSON(json) {
    return UserDetailsAdminDtoToJSONTyped(json, false);
}
function UserDetailsAdminDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'isVerified': value['isVerified'],
        'avatarUrl': value['avatarUrl'],
        'propertiesListed': value['propertiesListed'],
        'offersMade': value['offersMade'],
        'bidsMade': value['bidsMade'],
    };
}
